import { useEffect, useState } from "react";

export default function PaymentSuccess() {
  const [s, setS] = useState({ loading: true, ok: false, message: "" });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setS({ loading: false, ok: false, message: "Session ID bulunamadı." });
      return;
    }
    fetch(`/api/payments/checkout/status/${sessionId}`)
      .then(r => r.json())
      .then(d => {
        const ok = d.payment_status === 'paid' || d.status === 'complete' || d.status === 'completed';
        setS({ loading: false, ok, message: ok ? "Aboneliğiniz aktif edildi!" : (d.detail || "Ödeme doğrulanamadı.") });
      })
      .catch(() => setS({ loading: false, ok: false, message: "Doğrulama hatası." }));
  }, []);

  if (s.loading) return <div style={{padding: '24px'}}>Ödeme doğrulanıyor…</div>;
  if (!s.ok) return <div style={{padding: '24px'}}>Hata: {s.message}</div>;
  return <div style={{padding: '24px'}}>🎉 Teşekkürler! Aboneliğin aktif edildi.</div>;
}
